import React from 'react'
import { connect } from 'dva'
import { framework_tool, component_tool } from '@/tool'
let { WizContainer, WizReduxTemplate } = framework_tool
import { templateConfig, reduxTemplateCofig } from './config'
let { WizBrowserExport } = component_tool

class CertificateStatisticsCfg extends WizContainer {

    componentName = 'CertificateStatisticsCfg'

    constructor(props) {
        super(props)
        this.state = {
            addTimestamp: new Date().getTime()
        }
    }

    _handleCMD(nextProps, nextState, key) {
        let o = nextProps[key]
        if (o['success']) {
            wizNotice.success(o['msg'])
            return true
        } else {
            wizNotice.error(o['msg'])
            return false
        }
    }

    _getList(nextProps, nextState, key) {
        let { code, msg } = nextProps[key]
        if (code === 1) {
            return true
        } else {
            wizNotice.error(msg)
            return false
        }
    }

    _render() {
        let _reduxTemplateCofig = reduxTemplateCofig({
            templateConfig: templateConfig(this),
            apiDataFormat: {
                list: this._getList,
                enable: this._handleCMD
            },
        })
        return <WizReduxTemplate {..._reduxTemplateCofig} />
    }
}

const mapStateToProps = (state, ownProps) => {
    return {}
}

export default connect(mapStateToProps)(CertificateStatisticsCfg)
